import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../../helper/api";


export const verifyProfileOTP = createAsyncThunk(
  "verifyProfileOTP/verifyProfileOTP",
  async (payload, thunkAPI) => {
    try {
      const response = await api.post("verify-account",payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);

const verifyOTPSlice = createSlice({
  name: "verifyProfileOTP",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(verifyProfileOTP.pending, (state) => {
        state.loading = true;
      })
      .addCase(verifyProfileOTP.fulfilled, (state, action) => {
          
          
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(verifyProfileOTP.rejected, (state, action) => {
        
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default verifyOTPSlice.reducer;
